import { external_api } from 'app_config/globals'
import { moodleAuthChange } from 'app_events/auth/actions';
import { CombinedReducers } from 'app_events/index'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification';
import React, { FC, ReactElement, useCallback, useMemo, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux';

interface ILoginMoodleProps {
  children: ReactElement
  redirectTo?: string
  targetBlank?: boolean
}

const MOODLE_LOGIN_WAIT = 3000
const DEFAULT_HOME_URL = `${external_api?.moodle?.url}${external_api?.moodle?.redirect ?? '/?redirect=0'}`

const LoginMoodle: FC<ILoginMoodleProps> = ({ children, redirectTo, targetBlank }) => {
  const form = useRef<HTMLFormElement>(null)
  const auth = useSelector((state: CombinedReducers) => state.auth)
  const moodleData = useMemo(() => auth?.user?.data?.moodle, [auth])
  const isMoodleAuth = useSelector((state: CombinedReducers) => state.auth.moodleAuth)
  const dispatch = useDispatch()
  const screenNotifications = useMemo(() => new ScreenNotificationsUtil(), [])

  const moodleLoginRequest = useCallback(() => {
    if (!!form?.current) {
      if (moodleData?.password && moodleData.username) {
        form.current.submit()
        dispatch(moodleAuthChange(true))
      }
    }
  }, [dispatch, moodleData])

  const openUrl = useCallback((url: string) => {
    if (targetBlank) {
      window.open(url, '_blank', 'noreferrer')
    } else {
      window.location.href = url
    }
  }, [targetBlank])

  const handleClickLogin = useCallback(async () => {
    if (redirectTo) {
      if (!isMoodleAuth) {
        moodleLoginRequest()
        await screenNotifications.fire({
          'message': 'Iniciando sesión en moodle',
        }, {
          'type': 'warning',
          'showCancelButton': false,
          'showConfirmButton': false,
          'allowOutsideClick': false,
          'allowEscapeKey': false,
          timer: MOODLE_LOGIN_WAIT,
        })
      }
      openUrl(redirectTo)
    } else {
      if (!isMoodleAuth) {
        moodleLoginRequest()
      } else {
        openUrl(DEFAULT_HOME_URL)
      }
    }
  }, [
    moodleLoginRequest,
    isMoodleAuth,
    redirectTo,
    screenNotifications,
    openUrl
  ])

  return (
    <form
      target='_blank'
      method="POST"
      action={`${external_api?.moodle?.url}/login/index.php`}
      ref={form}
    >
      <input type="hidden" name="username" value={`${moodleData?.username}`} />
      <input type="hidden" name="password" value={`${moodleData?.password}`} />
      <div onClick={handleClickLogin}>
        {children}
      </div>
    </form>
  )
}

export default LoginMoodle
